import React, { Component } from 'react';
import QRCode from 'qrcode.react';
import './index.less';

export default class Code extends Component {
    render() {
        const { noticePK } = this.props;
        return (
            <div className="qrCode">
                {
                    noticePK 
                        ? <QRCode value={ noticePK } fgColor='#000000' className="qrCode-size" ></QRCode>
                        : <div></div>
                }
            </div>
        )
    }
}
